// extracted by mini-css-extract-plugin
module.exports = {"btn-expand":"smarter-energy-insights_btn-expand__1ddS_","expandable":"smarter-energy-insights_expandable__3VNZw","expanded":"smarter-energy-insights_expanded__d-Eda"};